import { IRouteItem } from '../router';

export interface IRouteList {
  [x: string]: any;
  HomeLogin: IRouteItem;
  // Select_Agency: IRouteItem; // เพิ่มบรรทัดนี้
}

const login = '/';
const LoginGuest = '/LoginGuest'; // กำหนดลิงก์สำหรับหน้าใหม่

const Route: IRouteList = {
  HomeLogin: {
    link: `${login}`,
    name: 'HomeLogin',
  },
  LoginGuest: { // เพิ่มบรรทัดนี้
    link: `${LoginGuest}`,
    name: 'LoginGuest',
  },
  // Select_Agency: { // เพิ่มบรรทัดนี้
  //   link: `${Select_Agency}`,
  //   name: 'Select_Agency',
  // },
};

export default Route;